import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBook, FaEye, FaPlus } from "react-icons/fa";
import styles from "./ListSubject.module.css";
import { CustomButton } from "../../../../components";
import CustomMRTTable from "../../../../components/CustomMRTTable/CustomMRTTable";
import AxiosInstance from "../../../../services/Api";
import { useSelector } from "react-redux";

const ListSubject = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [apiSearch, setApiSearch] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
 const {  translations } = useSelector((state) => state.language);
  /* ===========================
     FETCH SUBJECT LIST
     =========================== */
  useEffect(() => {
    fetchSubjectList();
  }, [pagination.pageIndex, pagination.pageSize, apiSearch]);

  const fetchSubjectList = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post("/school/listSubject", {
        page: pagination.pageIndex + 1,
        limit: pagination.pageSize,
        search: apiSearch,
      });

      if (response?.data?.rows) {
        setData(response.data.rows || []);
        setRowCount(response.data.total || 0);
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching subject list", error);
      setData([]);
      setRowCount(0);
    } finally {
      setLoading(false);
    }
  };

  /* ===========================
     HANDLERS
     =========================== */
  const handleAdd = () => {
    navigate("/user/CreateSubject");
  };

  const handleView = (row) => {
    navigate("/user/CreateSubject", {
      state: {
        ID: row.id,
        data: row,
      },
    });
  };

  /* ===========================
     TABLE COLUMNS (SUBJECT ONLY)
     =========================== */
  const columns = useMemo(
    () => [
      {
        accessorKey: "subject_name",
        header: translations.labels.subjectName,
        enableSorting: true,
      },
      {
        id: "actions",
        header: translations.labels.actions,
        enableSorting: false,
        Cell: ({ row }) => (
          <button
            className={styles.viewBtn}
            onClick={() => handleView(row.original)}
            title="View"
          >
            <FaEye />
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div className={styles.container}>
      {/* HEADER */}
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaBook />
        </div>
        <h1 className={styles.headerTitle}>{translations.labels.subjectList}</h1>
      </div>

      {/* ADD BUTTON */}
      <div className={styles.actions}>
        <CustomButton
          type="button"
          variant="contained"
          className={styles.addButton}
          fullWidth={false}
          onClick={handleAdd}
        >
           <FaPlus style={{ marginRight: "8px" }} />
       {translations.labels.add}
        </CustomButton>
      </div>

      {/* TABLE */}
      <CustomMRTTable
        columns={columns}
        data={data}
        loading={loading}
        pagination={pagination}
        rowCount={rowCount}
        placeholder={translations.labels.selectsubjectPlaceholder }
        onPaginationChange={setPagination}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        onSearchEnter={(value) => {
          setApiSearch(value);
          setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        }}
        enableFiltering={false}
      />
    </div>
  );
};

export default ListSubject;